import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

const Checkbox = forwardRef(
  ({ labelText, className, checked, id, ...props }, ref) => (
    <S.Label htmlFor={id}>
      <S.CheckboxContainer className={className}>
        <S.HiddenCheckbox
          checked={checked}
          {...props}
          ref={ref}
          id={id}
          name={id}
        />
        <S.StyledCheckbox checked={checked}>
          <S.Icon viewBox="0 0 24 24">
            <polyline points="20 6 9 17 4 12" />
          </S.Icon>
        </S.StyledCheckbox>
        <span>{labelText}</span>
      </S.CheckboxContainer>
    </S.Label>
  ),
);

Checkbox.propTypes = {
  labelText: '',
  id: PropTypes.string,
  className: PropTypes.string,
  checked: PropTypes.bool,
};

Checkbox.defaultProps = {
  labelText: PropTypes.string,
  id: '',
  className: '',
  checked: false,
};

export default Checkbox;
